import PrimeVue from 'primevue/config';
import theme from '@js/theme.js';
import {
    InputText,
    Panel,
    Textarea,
    MultiSelect,
    Galleria,
    FileUpload,
    TreeSelect,
    ButtonGroup,
    Button,
    Image,
    Fieldset,
    DynamicDialog,
    DataTable,
    Column,
    Toast,
    Dialog,
    ConfirmPopup,
    Chip,
    Checkbox,
    Menu,
    Toolbar,
    ProgressSpinner,
    Avatar,
    TieredMenu,
    Tabs,
    TabPanel,
    TabList,
    TabPanels,
    ToggleSwitch,
    Tag,
    Message,
    InputGroupAddon,
    Badge,
    DatePicker,
    Skeleton,
    FocusTrap,
    Tooltip,
    InputNumber,
    InputMask,
    Password,
    Chips, Card, Tree, InputChips, Paginator, ProgressBar, SelectButton
} from 'primevue';
import ToastService from 'primevue/toastservice';
import Tab from 'primevue/tab';
import Editor from 'primevue/editor';

export default function(app) {
    app.component('Button', Button);
    app.component('InputText', InputText);
    app.component('InputNumber', InputNumber);
    app.component('InputMask', InputMask);
    app.component('Password', Password);
    app.component('Panel', Panel);
    app.component('Textarea', Textarea);
    app.component('MultiSelect', MultiSelect);
    app.component('Galleria', Galleria);
    app.component('FileUpload', FileUpload);
    app.component('TreeSelect', TreeSelect);
    app.component('ButtonGroup', ButtonGroup);
    app.component('Image', Image);
    app.component('Fieldset', Fieldset);
    app.component('DynamicDialog', DynamicDialog);
    app.component('DataTable', DataTable);
    app.component('Column', Column);
    app.component('Toast', Toast);
    app.component('Dialog', Dialog);
    app.component('ConfirmPopup', ConfirmPopup);
    app.component('Chip', Chip);
    app.component('Chips', Chips);
    app.component('Menu', Menu);
    app.component('Checkbox', Checkbox);
    app.component('Toolbar', Toolbar);
    app.component('ProgressSpinner', ProgressSpinner);
    app.component('Avatar', Avatar);
    app.component('TieredMenu', TieredMenu);
    app.component('Tabs', Tabs);
    app.component('TabList', TabList);
    app.component('Tab', Tab);
    app.component('TabPanels', TabPanels);
    app.component('TabPanel', TabPanel);
    app.component('ToggleSwitch', ToggleSwitch);
    app.component('Tag', Tag);
    app.component('Message', Message);
    app.component('InputGroupAddon', InputGroupAddon);
    app.component('Badge', Badge);
    app.component('DatePicker', DatePicker);
    app.component('Skeleton', Skeleton);
    app.component('FocusTrap', FocusTrap);
    app.component('Card', Card);
    app.component('Tree', Tree);
    app.component('InputChips', InputChips);
    app.component('Paginator', Paginator);
    app.component('ProgressBar', ProgressBar);
    app.component('SelectButton', SelectButton);
    app.component('Editor', Editor);

    app.directive('Tooltip', Tooltip);

    app.use(PrimeVue, {
        theme,
        locale: {
            firstDayOfWeek: 1,
            dayNames: ['nedeľa', 'pondelok', 'utorok', 'streda', 'štvrtok', 'piatok', 'sobota'],
            dayNamesShort: ['ned', 'pon', 'uto', 'str', 'štv', 'pia', 'sob'],
            dayNamesMin: ['Ne', 'Po', 'Ut', 'St', 'Št', 'Pi', 'So'],
            monthNames: ['január', 'február', 'marec', 'apríl', 'máj', 'jún', 'júl', 'august', 'september', 'október', 'november', 'december'],
            monthNamesShort: ['jan', 'feb', 'mar', 'apr', 'máj', 'jún', 'júl', 'aug', 'sep', 'okt', 'nov', 'dec'],
            today: 'Dnes',
            clear: 'Vymazať'
        }
    });
    app.use(ToastService);
}